import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";

const SECTIONS = [
  {
    title: "Chat with Grapho",
    body: "Tap the chat bubble in the bottom-right corner — a human from the studio answers, usually within minutes during production hours.",
  },
  {
    title: "How Grapho Works",
    body: "1. Brief it — give us the idea. 2. We build it — creative direction plus original production. 3. We review it — final quality checks. 4. You download it — ready for your store.",
  },
  {
    title: "Billing questions",
    body: "1 credit = 1 production request. Credits reset at the start of each cycle and don't roll over. References are free. Cancellations are processed before your next billing date; unused credits stay usable until the end of the cycle.",
  },
  {
    title: "Design and revision questions",
    body: "Every delivered design includes a commercial licence for your shop. Need a variation, a new phrase, or a seasonal version? Open the project and submit a follow-up brief — the studio keeps your creative direction.",
  },
];

const FAQS = [
  ["Can I use the designs on Printify and Printful?", "Yes — files ship as production-ready PNGs that match major POD specs."],
  ["Do I own the designs after delivery?", "Yes — full commercial licence for your shop."],
  ["What if I don't like the result?", "Open the project and request a variation — the studio keeps your brief and style context."],
  ["Can I sell them as digital downloads?", "Yes."],
];

export default function HelpPage() {
  return (
    <div data-testid="help-page">
      <p className="font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-sky-400">Grapho Studio</p>
      <h1 className="mt-2 text-2xl font-extrabold tracking-tight text-white sm:text-3xl">Help and Support</h1>

      <div className="mt-8 space-y-4">
        {SECTIONS.map((s) => (
          <div key={s.title} data-testid={`help-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="glass rounded-2xl p-5">
            <p className="flex items-center gap-2 text-sm font-bold text-white">
              {s.title === "Chat with Grapho" && <MessageCircle className="h-4 w-4 text-emerald-400" />}
              {s.title}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.body}</p>
          </div>
        ))}

        <div className="glass rounded-2xl p-5" data-testid="help-faqs">
          <p className="text-sm font-bold text-white">Frequently asked questions</p>
          <div className="mt-3 space-y-3">
            {FAQS.map(([q, a]) => (
              <div key={q} className="rounded-xl border border-white/10 bg-white/5 p-4">
                <p className="text-sm font-semibold text-slate-200">{q}</p>
                <p className="mt-1 text-sm text-slate-400">{a}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="glass rounded-2xl p-5">
          <p className="text-sm font-bold text-white">Ready for your next design?</p>
          <Link
            to="/dashboard/new"
            data-testid="help-new-brief-button"
            className="mt-3 inline-flex items-center gap-2 rounded-full bg-amber-400 px-5 py-2.5 text-xs font-bold text-[#1A1204] transition-colors hover:bg-amber-300"
          >
            Submit a New Brief
          </Link>
        </div>
      </div>
    </div>
  );
}
